import {BaseService} from "./base.service";

class ImportSinesterFileService extends BaseService {

    constructor() {
        super('api/import-sinester-file')
    }

}

export const importsinesterfileService = new ImportSinesterFileService();
